import { useState, useEffect } from "react";
import { Form, Row, Col, Card, Container, Button } from "react-bootstrap";
import ImpostazioniComuneService from "../../../services/ImpostazioniComuneService";
import ModalConferma from "../../Utilities/ModalConferma";
import Categorie from "../Utilities/Categorie";
/*
PROPS
 sondaggi = {sondaggi}
stopLoading={stopLoading}
setStopLoading={setStopLoading}
setDirty={setDirty}
comune={props.comune}
setRicaricaComune={props.setRicaricaComune}
setMostraTabella={props.setMostraTabella}
*/

export default function ImpostazioniSondaggi(props) {

    let [categorie, setCategorie] = useState([])

    // Stati per le finestre modali
    const [mostraModaleConferma, setMostraModaleConferma] = useState(false)
    const [mostraModaleSuccesso, setMostraModaleSuccesso] = useState(false)
    const [mostraModaleErrore, setMostraModaleErrore] = useState(false)

    const salvaImpostazioni = () => {
        let impostazioni = {
            ...props.comune.impostazioniComune,
            imcCategorieSondaggi: { categorie_sondaggi: [...categorie] },
            comune: props.comune
        }

        ImpostazioniComuneService.aggiornaImpostazioni(impostazioni)
            .then(res => {
                if (res.status === 200) {
                    setMostraModaleConferma(false)
                    setMostraModaleSuccesso(true)
                    props.setRicaricaComune(true)
                  props.setMostraTabella(!props.ultimoGestisci)

                } else if (res.status === 500) {
                    setMostraModaleConferma(false)
                    setMostraModaleErrore(true)
                }
            }).catch(err => {
                setMostraModaleConferma(false)
                setMostraModaleErrore(true)
            })
    }

    useEffect(() => {
        setCategorie((props.comune.impostazioniComune && props.comune.impostazioniComune.imcCategorieSondaggi && props.comune.impostazioniComune.imcCategorieSondaggi.categorie_sondaggi) || [])
        props.setStopLoading(true)
    }, [props.comune, props])

    return (
        <>
            <Form>
                <Row className="d-flex">
                    <Col xs={12}>
                        <Card className="h-100 p-3 pt-0">
                            <Form.Group as={Col} className="mb-4 h-100">
                                <Form.Label column sm="6" className="pb-0">
                                    <p className="mb-2">Categorie per i sondaggi</p>
                                </Form.Label>
                                <Categorie categorie={categorie} setCategorie={setCategorie} />
                            </Form.Group>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <Container className="d-flex justify-content-end w-90 p-0 pt-5">
                <Button onClick={() => { setMostraModaleConferma(true) }}>Aggiorna</Button>
            </Container>

            <ModalConferma
                mostra={mostraModaleConferma}
                setMostra={setMostraModaleConferma}
                mode="continua"
                titolo="Salvataggio impostazioni"
                messaggio="Confermi il salvataggio delle impostazioni?"
                bodyAlign="text-center"
                btnConferma="Si, salva"
                btnAnnulla="No, annulla"
                azioneAnnulla={() => { setMostraModaleConferma(false) }}
                azioneConferma={salvaImpostazioni}
            />

            <ModalConferma
                mostra={mostraModaleSuccesso}
                setMostra={setMostraModaleSuccesso}
                mode="success"
                titolo="Salvataggio impostazioni"
                messaggio="Impostazioni aggiornate con successo"
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={() => { setMostraModaleSuccesso(false) }}
            />

            <ModalConferma
                mostra={mostraModaleErrore}
                setMostra={setMostraModaleErrore}
                mode="error"
                titolo="Salvataggio impostazioni"
                messaggio="Si è verificato un errore durante l'aggiornamento delle impostazioni"
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={() => { setMostraModaleErrore(false) }}
            />
        </>
    )
}